/**
 * Decide the content to persist/show for a completed assistant turn so it is
 * NEVER silently dropped.
 *
 * A reasoning-capable model can finish a turn (finish_reason: "stop") with only
 * "thinking" tokens and no visible text and no tool calls. Without a fallback the
 * streamed bubble is cleared on completion and nothing is added or saved, leaving
 * the user's message dangling as the last message in the chat. This helper
 * guarantees a non-empty content string in every case.
 */
export function resolveAssistantContent(accumulatedText: string, hasToolParts: boolean): string {
  if (accumulatedText) return accumulatedText
  if (hasToolParts) {
    return '✓ Actions completed. Continue the conversation to see results or ask a follow-up question.'
  }
  // No visible text and no tool calls — e.g. a reasoning-only / empty turn.
  return 'The assistant ended its turn without a visible reply. Send "continue" or rephrase your request.'
}
